import React from "react"

import NavItem from "../NavItem"

import { getLink } from "../../../utils"
import { NavGroupModel } from "../../../models/nav"
import useDictionary from "../../../hooks/useDictionary"

interface SidebarMenuProps extends NavGroupModel {
  cssClass?: string
  pageContext: any
}

const defaultProps = {}

export const SidebarMenu: React.FC<SidebarMenuProps> = props => {
  // console.log("SidebarMenu: ", props)
  const [pathname, setPathname] = React.useState("")

  React.useEffect(() => {
    setPathname(location.pathname)
  }, [])

  if (!props.links) return null

  return (
    <div className="sidebar__menu embed">
      <div className="menu__heading">{useDictionary("Take a look", props.pageContext.locale)}</div>
      <ul className="menu__menu">
        {props.links.map(link => {
          const url = getLink(link.main_link[0])
          // disable link if current page
          if (url?.url === pathname)
            return (
              <li key={link.id} className="menu__menuItem" role="presentation">
                <div className="navLink" role="menuitem">
                  {link.label}
                </div>
              </li>
            )
          return (
            <NavItem
              key={link.id}
              {...link}
              cssClass="menu__menuItem"
              pageContext={props.pageContext}
            />
          )
        })}
      </ul>
    </div>
  )
}

SidebarMenu.defaultProps = defaultProps

export default SidebarMenu
